<template>
  <div>
    <!-- <v-btn v-if="!authenticated" outline @click="onConnect">Sign-in</v-btn> -->
    <button v-if="!authenticated" @click="onConnect" class="mt-1">
      <img src="../../assets/btn_strava_connectwith_light.png">
    </button>
    <v-layout v-if="authenticated" align-center row>
      <v-menu>
        <v-btn flat class="text-capitalize" slot="activator">
          <v-layout v-if="authenticated" align-center row>
            <h3 class="font-weight-thin mr-2">{{ `${athlete.firstname} ${athlete.lastname}` }}</h3>
            <!-- <img :src="athlete.profile" height="32" width="32" style="margin-top: 1px" /> -->
            <v-icon>more_vert</v-icon>
          </v-layout>
        </v-btn>
        <v-list>
          <template v-for="(item, index) in sessionItems">
            <v-divider v-if="item.text === 'divider'" :key="index"/>
            <v-list-tile
              v-if="item.text !== 'divider'"
              :key="index"
              @click="onSessionClick(item.args)"
            >
              <v-list-tile-action>
                <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
              </v-list-tile-action>
              <v-list-tile-title>{{ item.text }}</v-list-tile-title>
            </v-list-tile>
          </template>
        </v-list>
      </v-menu>
    </v-layout>
    <reset-modal :show="showReset" @reset="onReset"/>
    <preferences-modal :show="showPreferences" @closed="showPreferences = false"/>
  </div>
</template>

<script>
import StravaAuth from '@/domain/StravaAuth';
import Athlete from '@/ux/components/Athlete.vue';
import cache from '@/cache/indexedDB/indexedDbCache';
import ResetModal from '@/ux/components/modals/ResetModal.vue';
import PreferencesModal from '@/ux/components/modals/PreferencesModal.vue';

export default {
  name: 'session',
  components: { Athlete, ResetModal, PreferencesModal },
  data: () => ({
    sessionItems: [
      { text: 'sign out', icon: 'exit_to_app', args: 'sign-out' },
      { text: 'divider' },
      { text: 'Preferences', icon: 'settings', args: 'preferences' },
      { text: 'divider' },
      { text: 'Reset', icon: 'error_outline', args: 'reset' },
    ],
    showReset: false,
    showPreferences: false,
  }),
  computed: {
    authenticated() {
      return this.$store.state.token !== null;
    },
    athlete() {
      return this.$store.state.athlete;
    },
  },
  methods: {
    onConnect() {
      new StravaAuth().navigateOAuth();
    },
    onReset() {
      this.showReset = false;
      cache.destroy();
      this.$store.commit('signOut');
      this.$router.push({ name: 'home' });
    },
    onSessionClick(args) {
      switch (args) {
        case 'sign-out':
          this.$store.commit('signOut');
          this.$router.push({ name: 'home' });
          break;
        case 'reset':
          this.showReset = true;
          break;
        case 'preferences':
          this.showPreferences = true;
          break;
      }
    },
  },
};
</script>

<style>
img.rounded-image {
  border-radius: 25%;
}
</style>
